// src/components/Missions/missionsData.ts

export interface MissionSection {
    id: string;
    label: string;
    imagePath: string;
    content: string[];
  }
  
  export const missionSections: MissionSection[] = [
    {
      id: '#compassionate-care',
      label: 'Compassionate Care',
      imagePath: '/images/compassionate-care-icon.png',
      content: [
        `We commit to delivering comprehensive, expert care that nurtures 
         the whole person — body, mind, and spirit — through expert symptom 
         management and personalized support, ensuring that every moment of 
         life is lived with meaning, comfort, and grace for those with 
         incurable conditions.`,
        `We commit to pioneering evidence-based symptom management strategies 
         that put patient well-being first, building upon and enhancing 
         current site-specific practice guidelines.`,
        `We are committed to providing families with the necessary support 
         by ensuring they are informed, involved, and empowered in symptom 
         management, creating a partnership in care delivery.`,
        `We commit to fostering collaborative partnerships with stakeholders 
         and policymakers to develop innovative, patient-centered approaches 
         to symptom management that advance care standards.`,
      ],
    },
    {
      id: '#education',
      label: 'Education',
      imagePath: '/images/education-icon.png',
      content: [
        `We commit to developing highly skilled healthcare teams through 
         comprehensive training in coordinated, holistic care to address 
         the complex needs of patients with life-limiting illnesses.`,
        `We commit to empowering patients and families through comprehensive 
         educational resources that enhance understanding of their conditions, 
         treatment options, and available support services, enabling informed 
         decisions that improve quality of life.`,
        `We commit to advancing palliative care education through strategic 
         partnerships with academic and private institutions, focusing on 
         symptom management, communication skills, and hospice care principles 
         to elevate care standards.`,
        `We commit to enriching community understanding of palliative and 
         hospice care through engaging educational events, digital learning 
         opportunities, and outreach programs that build awareness and support.`,
      ],
    },
    {
      id: '#community',
      label: 'Community',
      imagePath: '/images/community-icon.png',
      content: [
        `We commit to building resilient communities by creating meaningful 
         connections among patients and families, fostering an environment 
         where shared experiences lead to mutual strength and understanding.`,
        `We commit to ensuring accessible, professional support through our 
         network of skilled counselors, social workers, and healthcare providers 
         who deliver personalized guidance to meet each individual’s unique needs.`,
        `We commit to nurturing peer support programs that empower individuals 
         to share experiences and wisdom, creating a culture of empathy, 
         encouragement, and mutual growth.`,
        `We commit to promoting holistic well-being through specialized 
         workshops and activities that address emotional, spiritual, and social 
         aspects of healing, supporting each person's unique journey.`,
      ],
    },
    {
      id: '#spiritual-care',
      label: 'Spiritual Care',
      imagePath: '/images/spiritual-care-icon.png',
      content: [
        `To provide Christ-centered spiritual counseling and guidance, empowering 
         individuals and families to find strength, healing, and hope through 
         their faith journey during challenging times.`,
        `To build a nurturing faith community through support groups and worship 
         gatherings that foster spiritual growth, shared experiences, and 
         deepened connections with God and one another.`,
        `To equip believers with comprehensive spiritual resources and educational 
         materials that strengthen their faith foundation and cultivate 
         lasting spiritual resilience.`,
        `To deliver holistic spiritual care that integrates faith-based 
         practices and biblical wisdom into every aspect of our support services, 
         ensuring Christ remains at the center of our ministry to those in need.`,
      ],
    },
    {
      id: '#hospice-care',
      label: 'Hospice Care',
      imagePath: '/images/hospice-care-icon.png',
      content: [
        `To provide specialized end-of-life care through a dedicated team 
         of professionals who offer comprehensive support addressing 
         physical symptoms, psychosocial needs, and spiritual well-being 
         while honoring personal and cultural preferences.`,
        `To create nurturing environments, whether at home or in our facilities, 
         where individuals and families receive compassionate care, meaningful 
         support, and the resources needed to navigate their end-of-life 
         experience with peace and dignity.`,
        `To extend our circle of care beyond immediate medical needs through 
         ongoing bereavement support, counseling services, and grief resources 
         that support families through their entire journey of loss and healing.`,
      ],
    },
  ];
  